import React from 'react';
import { useRecoilValue } from 'recoil';
import { allTiresState } from 'features/file-browser/state/fileAtoms';
import { isVisibleTireState } from 'features/three-view/state/threeAtoms';
import { StlViewer } from '../utils/stlViewer';

export const TireViewer: React.FC = () => {
  const allTires = useRecoilValue(allTiresState);
  const isVisibleTire = useRecoilValue(isVisibleTireState);

  if (!allTires.length || !isVisibleTire) return <></>;

  const getFileName = (name: string) => {
    return name.split('.').slice(0, -1).join('.');
  };

  return (
    <>
      {allTires.map((s3file, index) => (
        <StlViewer
          key={`${s3file.url}-${index}`}
          url={s3file.url}
          name={getFileName(s3file.name)}
          defaultColor={'#ff9900ff'}
          label='Tire'
        />
      ))}
    </>
  );
};
